import { render, staticRenderFns } from "./ClassroomOAuth.vue?vue&type=template&id=0f6380fc&scoped=true"
import script from "./ClassroomOAuth.vue?vue&type=script&lang=js"
export * from "./ClassroomOAuth.vue?vue&type=script&lang=js"
import style0 from "./ClassroomOAuth.vue?vue&type=style&index=0&id=0f6380fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6380fc",
  null
  
)

export default component.exports